// Müşteri portalı kabuğu — /api/v1/portal/{firms,branding} (K8, Finar 2026-10-23). Erişimsiz
// firmada 403 KPI_CLIENT_FORBIDDEN (asla PARTICIPATION_ENDED — kickout tetiklenmez).

import type {
  ClientProjectsListResponse,
  PortalBranding,
  PortalFirm,
  PortalFirmsResponse,
} from "@mahir/shared";
import { api } from "./client";

export async function listPortalFirms(): Promise<PortalFirm[]> {
  const res = await api<PortalFirmsResponse>("/portal/firms");
  return res.firms;
}

export async function getPortalBranding(clientId: string): Promise<PortalBranding> {
  return api<PortalBranding>(`/portal/branding?clientId=${encodeURIComponent(clientId)}`);
}

/** Rota projesinin firması (çok firmalı kullanıcının derin bağlantısı için) — yoksa null. */
export async function findProjectClientId(projectId: string): Promise<string | null> {
  const res = await api<ClientProjectsListResponse>("/projects?limit=100");
  return res.projects.find((p) => p.id === projectId)?.clientId ?? null;
}
